module.exports = __webpack_public_path__ + "static/img/illus-02.93c87b6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illus-02.webp
// module id = 103
// module chunks = 0